import React, { useEffect, useState } from "react";
import { post, setBearerToken, setCompanyId, setBranchId } from "@/security/Axios";
import ToastMe from "@/components/ui/ToastMe";

const BRAND = { background: "#f4f6fb", primary: "#156372", accent: "#FFC107" };

export default function WelcomeSSOPage() {
  const [msg, setMsg] = useState("Signing you in…");
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");

    if (!token) {
      setBusy(false);
      setMsg("Missing token in the URL.");
      ToastMe("Missing token.", "error");
      return;
    }

    (async () => {
      try {
        const res = await post("/auth/consume-sso", { token });
        const data = res?.data || {};
        if (!data?.ok || !data?.token) {
          throw new Error(data?.message || "Invalid SSO response.");
        }

        // Persist auth + tenant headers for your Axios layer
        setBearerToken(data.token);
        if (data.company_id) setCompanyId(String(data.company_id));
        if (data.branch_id)  setBranchId(String(data.branch_id));

        ToastMe("Signed in successfully.", "success");
        window.location.replace("/admin/dashboard");
      } catch (e) {
        setMsg(e?.message || "Login failed.");
        ToastMe(e?.message || "Login failed.", "error");
        setBusy(false);
      }
    })();
  }, []);

  return (
    <section
      className="min-h-screen flex items-center justify-center px-4 py-12"
      style={{ backgroundColor: BRAND.background }}
    >
      <div className="w-full max-w-xl">
        <div className="rounded-3xl shadow-xl border border-slate-200 overflow-hidden bg-white">
          <div
            className="px-6 py-8 md:px-10 md:py-12 text-center text-white"
            style={{ background: `linear-gradient(135deg, ${BRAND.primary} 0%, ${BRAND.accent} 100%)` }}
          >
            <h1 className="text-3xl md:text-4xl font-semibold text-white">Welcome</h1>
            <p className="text-white/90 mt-2">We’re verifying your secure sign-in link…</p>
          </div>

          <div className="px-6 py-8 md:px-10 md:py-12">
            <div className="rounded-2xl border px-4 py-4 bg-white shadow-sm text-slate-700">
              {busy ? "Please wait…" : msg}
            </div>

            {!busy && (
              <div className="mt-6 text-center">
                <a
                  href="/sign-in"
                  className="inline-flex items-center justify-center rounded-xl px-6 py-2 font-semibold border border-slate-200 hover:bg-slate-50"
                >
                  Go to Sign in
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
